module.exports = __webpack_public_path__ + "static/logo_as_white-9aa527508d0f9689d78fd8c7f551c1fe.png";